import TweetCard from "../twitter/Tweet";
import { IReports, ITweet } from "../../types/CommonTypes";
import { getImageById } from "../../commons/constants/helpers";
import Fade from "react-reveal/Fade";
import "./Reports.css";
import "../../styles/mobile-carousel.css";

interface IProps {
	item: IReports;
}

export default function Reports(props: IProps) {
	// una fila del admin sin enlace todavía no puede renderizarse
	const tweets = props.item.tweets.filter((tweet: ITweet) => tweet.id);
	const { images } = props.item;
	const titleImage = getImageById("title", { images: images, texts: [] });

	return (
		<div className="reports-container">
			<div className="reports-title-wrapper">
				<img
					alt="Denuncias"
					src={titleImage}
					className="reports-title-image"
				/>
			</div>

			<Fade bottom duration={1000}>
				<div className="reports-content">
					<div className="reports-grid mobile-carousel">
						{tweets.map((item: ITweet, index: number) => (
							<TweetCard key={index} id={item.id} />
						))}
					</div>
				</div>
			</Fade>
		</div>
	);
}
